EASY.schedule.late(function () {
  var contextMenuObserving;
  var contextMenuUrl;
  var contextMenuRegister = [];

  function windowSize() {
    var w;
    var h;
    if (window.innerWidth) {
      w = window.innerWidth;
      h = window.innerHeight;
    } else if (document.documentElement) {
      w = document.documentElement.clientWidth;
      h = document.documentElement.clientHeight;
    } else {
      w = document.body.clientWidth;
      h = document.body.clientHeight;
    }
    return { width: w, height: h };
  }

  function contextMenuAddSelection(tr, target) {
    tr.addClass("context-menu-selection");
    contextMenuCheckSelectionBox(tr, true, target);
    contextMenuClearDocumentSelection();
    contextMenuRegister.push(tr.attr("id"));
  }

  function contextMenuCheckSelectionBox(tr, checked) {
    var input = tr
      .find('.checkbox input[type="checkbox"], .checkbox input[type="radio"], input.checkbox')
      .prop("checked", checked);
    input.change();
  }

  function contextMenuClearDocumentSelection() {
    if (document.selection) {
      document.selection.empty(); // IE
    } else {
      window.getSelection().removeAllRanges();
    }
  }

  function contextMenuIsSelected(tr) {
    return tr.hasClass("context-menu-selection");
  }

  function contextMenuCreate() {
    if ($("#context-menu").length < 1) {
      var menu = document.createElement("div");
      menu.setAttribute("id", "context-menu");
      menu.setAttribute("style", "display:none;");
      document.getElementById("content").appendChild(menu);
    }
  }

  function contextMenuToggleSelection(tr) {
    if (contextMenuIsSelected(tr)) {
      EASY.contextMenu.contextMenuRemoveSelection(tr);
    } else {
      contextMenuAddSelection(tr);
    }
  }

  function contextMenuUnselectAll() {
    $("input[type=checkbox].toggle-selection").prop("checked", false);
    $(".hascontextmenu").each(function () {
      EASY.contextMenu.contextMenuRemoveSelection($(this));
    });
    $(".cm-last").removeClass("cm-last");
  }

  function contextMenuSetLastSelected(tr) {
    $(".cm-last").removeClass("cm-last");
    tr.addClass("cm-last");
  }

  function contextMenuShow(event) {
    var menu = $("#context-menu");
    // menu.css('left', (render_x + 'px'));
    // menu.css('top', (render_y + 'px'));
    // menu.html('');

    $.ajax({
      url: $.data($(event.target).closest(".context-menu-container")[0], "contextMenuUrl"),
      data:
        $(event.target).closest("form").first().find("input:not(.easy-autocomplete-tag input)").serialize() +
        "&columns[]=" +
        $.map($("#selected_columns option"), function (option) {
          return option.value;
        }).join("&columns[]="),
      success: function (data, textStatus, jqXHR) {
        menu.html(data);
        EASY.contextMenu.contextMenuCalculatePosition(event, menu);
        initEasyAutocomplete();
        const firstLinkElement = menu.find("a").first();

        if (hasAriaControlsForContextMenu(event.target)) {
          // Focusing a submenu title pins its submenu open via li:focus-within.
          if (firstLinkElement.siblings("ul").length) {
            menu.attr("tabindex", "-1").trigger("focus");
          } else {
            firstLinkElement.trigger("focus");
          }
        }

        menu.on("keydown", function (e) {
          const hasSubmenu = $(e.target).hasClass("submenu");

          if (e.key === "Tab" && hasSubmenu) {
            toggleSubmenuExpanded(e);
          }

          if (e.key === "Escape" || (e.key === "Tab" && isLastElementFocused())) {
            e.preventDefault();
            handleCloseMenu(menu);
          }
        });
      },
    });
  }

  /**
   * Checks if the currently focused element is the last focusable element in the search form.
   * @returns {boolean} - true if the currently focused element is the last focusable element in the search form and
   * the shift key is not pressed, false otherwise.
   */
  function isLastElementFocused() {
    const menu = $("#context-menu");
    const focusableElements = menu[0].querySelectorAll('a, input, [tabindex]:not([tabindex="-1"])') ?? [];
    const visibleElements = Array.from(focusableElements).filter(element => !isHidden(element));
    const lastElement = visibleElements[visibleElements.length - 1];
    if (document?.activeElement) {
      return document.activeElement === lastElement;
    } else {
      return false;
    }
  }

  /**
   * Determines if the given element is hidden.
   *
   * @param {HTMLElement} element - The element to check for hidden state.
   * @returns {boolean} - True if the element is hidden, false otherwise.
   */
  function isHidden(element) {
    return element.offsetParent === null || element.offsetWidth === 0 || element.offsetHeight === 0;
  }

  /**
   * Toggles the expanded state of a submenu on focus out.
   * @param {Event} e - The trigger event.
   */
  function toggleSubmenuExpanded(e) {
    const trigger = $(e.target);
    const submenu = trigger.next("ul");
    const lastSubmenuItem = submenu.find("li > a").last();

    trigger.attr("aria-expanded", "true");

    // Listen for the focusout event on the submenu's last item
    lastSubmenuItem.on("focusout", function () {
      // Check if the newly focused element is outside the submenu
      if (!submenu.is(":focus-within")) {
        let submenuButton = $(e.target);
        submenuButton.attr("aria-expanded", "false");
        // Remove the focusout event listener
        lastSubmenuItem.off("focusout");
      }
    });
  }

  /**
   * Handles the closing of a menu.
   *
   * @param {jQuery} $menu - The menu to be closed.
   */
  function handleCloseMenu(menu) {
    menu.off("keydown");
    menu.hide();
    const contextMenuTriggerBtn = $(`#${contextMenuRegister}`).find(".ending-buttons-fixed a.btn_contextmenu_trigger");

    if (contextMenuTriggerBtn) contextMenuTriggerBtn.trigger("focus");
  }

  /**
   * Recursive search in element parents for position relative
   * @param {jQuery} $el
   * @return {null|jQuery}
   */
  function getFirstRelativeParentEl($el) {
    const $parent = $el?.parent();
    if (!$parent) return null;
    if ($parent[0]?.tagName?.toLowerCase() === "body") return null;
    const parentPosition = $parent.css("position");
    return parentPosition?.toLowerCase() === "relative" ? $parent : getFirstRelativeParentEl($parent);
  }

  /**
   * @param {jQuery} $menu
   * @return {null|{offsetX: number, offsetY: number}}
   */
  function getMenuOffsetXY($menu) {
    const $parentWithRelative = getFirstRelativeParentEl($menu);
    if (!$parentWithRelative) return { offsetX: 0, offsetY: 0 };
    const offset = $parentWithRelative.offset();
    return { offsetX: offset.left, offsetY: offset.top };
  }

  EASY.contextMenu.contextMenuPositionSubmenu = function (menu, sub_selector, window_height, window_width) {
    menu.find(sub_selector).each(function () {
      const $this = $(this);
      const rect = this.getBoundingClientRect();
      const parect = this.parentElement.getBoundingClientRect();

      const adjustTop = () => {
        const a = rect.top + rect.height - window_height;
        const max = rect.height - parect.height;
        const scrollTopOffset = document.documentElement.scrollTop || document.body.scrollTop || 0;
        const OFFSET = 20;
        let top = null;

        if (a > 0) {
          top = a > max ? -max : -a;
        }

        if (rect.top < 0 || rect.height > window_height) {
          $this.css("max-height", window_height - 2 * OFFSET);
          $this.css("overflow-y", "auto");

          if (rect.height > window_height + scrollTopOffset) {
            top = -parect.top + OFFSET / 2;
          } else {
            top = 0;
          }

          $this.css("bottom", "auto");
        }

        if (top !== null) $this.css("top", top);
      };

      const adjustLeft = () => {
        if (rect.left + rect.width - window_width > 0) $this.css("left", "-99%");
      };

      adjustTop();
      adjustLeft();
    });
  };

  /**
   * Checks if the event target has an aria-controls attribute set to "context-menu",
   * indicating it is a trigger for a context menu.
   *
   * @param {HTMLElement} target The event object containing pointer information.
   * @returns {boolean} - Returns true if the target controls the context menu, otherwise false.
   */
  function hasAriaControlsForContextMenu(target) {
    return target.getAttribute("aria-controls") === "context-menu";
  }

  /**
   * Retrieves pointer coordinates based on the event.
   * @param {MouseEvent | PointerEvent} event The event object containing pointer information.
   * @returns {Object} An object containing the x and y coordinates of the pointer, along with the client y coordinate.
   */
  function getPointerCoordinates(event) {
    /** @type {Element} */
    const target = event.target;

    let mouse_x, mouse_y, mouse_y_client;

    if (hasAriaControlsForContextMenu(target)) {
      let boundingBox = target.getBoundingClientRect();
      mouse_x = boundingBox.left + boundingBox.width / 2 + window.scrollX;
      mouse_y = boundingBox.top + boundingBox.height / 2 + window.scrollY;
      mouse_y_client = boundingBox.top;
    } else {
      mouse_x = event.pageX;
      mouse_y = event.pageY;
      mouse_y_client = event.clientY;
    }

    return {
      mouse_x,
      mouse_y,
      mouse_y_client,
    };
  }

  EASY.contextMenu.contextMenuCalculatePosition = function (event, menu) {
    var main = ERUI.main;
    const { mouse_x, mouse_y, mouse_y_client } = getPointerCoordinates(event);
    const { offsetY, offsetX } = getMenuOffsetXY(menu);
    var render_x = mouse_x;
    var render_y = mouse_y;
    var menu_width;
    var menu_height;
    var window_width;
    var window_height;
    var max_width;
    // var max_height;
    var topmenu_height;
    var max_height_client;
    var max_height_reverse;

    menu_width = menu.width();
    menu_height = menu.height();
    max_width = mouse_x + menu_width;
    // max_height = mouse_y + menu_height;
    max_height_client = mouse_y_client + menu_height;
    topmenu_height = ERUI.topMenu[0].offsetHeight;
    max_height_reverse = menu_height + topmenu_height;

    window_width = main.width(); //ws.width;
    window_width = windowSize().width; //ws.width;

    window_height = document.documentElement.clientHeight;
    /* display the menu above and/or to the left of the click if needed */
    if (max_width > window_width) {
      render_x -= menu_width;
      menu.addClass("reverse-x");
    } else {
      menu.removeClass("reverse-x");
    }
    if (max_width + menu_width > window_width) {
      menu.addClass("reverse-submenu-x");
    } else {
      menu.removeClass("reverse-submenu-x");
    }
    // if (max_height > window_height) {
    if (max_height_client > window_height && mouse_y > max_height_reverse) {
      render_y -= menu_height;
      menu.addClass("reverse-y");
    } else {
      menu.removeClass("reverse-y");
    }
    // if (render_x <= 0)
    //     render_x = 1;
    // if (render_y <= 0)
    //     render_y = 1;
    // if (render_y < -60) {
    //     render_y = 1;
    // } else if (-60 < render_y < 0) {
    //     render_y = -1;
    // }

    // fallback on mobile devices
    // mobile devices does not have event "mouseDown" but "touchstart", so variables render_x and render_y are undefined
    if (!render_x || !render_y) {
      var $targetOffset = $(event.target).offset();
      render_x = $targetOffset.left;
      render_y = $targetOffset.top;
    }

    render_x -= offsetX;
    render_y -= offsetY;

    menu.css("left", render_x + "px");
    menu.css("top", render_y + "px");
    menu.show();

    EASY.contextMenu.contextMenuPositionSubmenu(menu, "li.folder > ul", window_height, window_width);

    //if (window.parseStylesheets) { window.parseStylesheets(); } // IE
  };

  EASY.contextMenu.contextMenuRightClick = function (event) {
    if (!$(event.target).closest(".context-menu-container")[0]) {
      return;
    }
    var ctx_url = $.data($(event.target).closest(".context-menu-container")[0], "contextMenuUrl");
    if (ctx_url === "") return;
    var target = $(event.target);
    if (
      target.is("a") &&
      !target.hasClass("icon-more-horiz") &&
      !target.hasClass("js-contextmenu") &&
      !target.parents("tr").hasClass("context-menu-selection")
    ) {
      return;
    }
    var tr = target.parents("tr").first();
    if (!tr.hasClass("hascontextmenu")) {
      return;
    }
    event.preventDefault();
    if (!contextMenuIsSelected(tr)) {
      contextMenuUnselectAll();
      contextMenuAddSelection(tr);
      contextMenuSetLastSelected(tr);
    }
    contextMenuShow(event);
  };

  EASY.contextMenu.contextMenuClick = function (event) {
    var target = $(event.target);
    var lastSelected;
    const contextMenu = $("#context-menu");

    // Check if the context menu is visible and the click is outside the context menu
    if (contextMenu.is(":visible") && target.closest("#context-menu").length === 0) {
      contextMenu.hide();
      return;
    }

    // If the click is outside of any context menu container, return
    if (!$(event.target).closest(".context-menu-container")[0]) {
      return;
    }

    // Prevent default action for submenu links and tags within the autocomplete
    if ((target.is("a") && target.hasClass("submenu")) || target.parents().hasClass("easy-autocomplete-tag")) {
      event.preventDefault();
      return;
    }

    // Ignore input clicks unless they are within a checkbox container
    if (target.is("input") && !target.closest(".checkbox").length) {
      return;
    }
    contextMenu.hide();
    if (target.is("a") || target.is("img") || target.hasClass("expander") || target.hasClass("expander-root")) {
      return;
    }
    if (event.which === 1 || navigator.appVersion.match(/\bMSIE\b/)) {
      var tr = target.parents("tr").first();
      if (tr.length && tr.hasClass("hascontextmenu")) {
        // a row was clicked
        if (target.is("td.checkbox")) {
          // the td containing the checkbox was clicked, toggle the checkbox
          target = target.find("input").first();
          target.prop("checked", !target.prop("checked"));
        }
        if (target.is("input")) {
          if (target.is('input[type="radio"]')) {
            contextMenuUnselectAll();
            if (!target.prop("checked")) {
              contextMenuAddSelection(tr, target);
            }
          } else if (target.prop("checked")) {
            contextMenuAddSelection(tr);
          } else {
            EASY.contextMenu.contextMenuRemoveSelection(tr);
          }
        } else {
          if (event.ctrlKey || event.metaKey) {
            contextMenuToggleSelection(tr);
          } else if (event.shiftKey) {
            lastSelected = $(".cm-last").first();
            if (lastSelected.length) {
              var toggling = false;
              $(".hascontextmenu").each(function () {
                if (toggling || $(this).is(tr)) {
                  contextMenuAddSelection($(this));
                }
                if ($(this).is(tr) || $(this).is(lastSelected)) {
                  toggling = !toggling;
                }
              });
            } else {
              contextMenuAddSelection(tr);
            }
          } else {
            contextMenuUnselectAll();
            contextMenuAddSelection(tr, target);
          }
          contextMenuSetLastSelected(tr);
        }
      } else {
        // click is outside the rows
        if (contextMenuRegister.length > 0) {
          if (!target.is("a") || !(target.hasClass("disabled") || target.hasClass("submenu")) || target.is("input")) {
            if (!target.closest(".ui-dialog-content").is("*")) {
              contextMenuUnselectAll();
            }
          }
        }
      }
    }
  };

  EASY.contextMenu.init = function (url, element) {
    var context_menu_parent = $(element);
    if (context_menu_parent[0]) {
      var has_el_context_menu = url !== "";
      context_menu_parent.each(function () {
        $.data(this, "contextMenuUrl", url);
        $(this).addClass("context-menu-container");
      });
      contextMenuCreate();
      if (!contextMenuObserving) {
        ERUI.document.click(EASY.contextMenu.contextMenuClick);
        if (has_el_context_menu) {
          ERUI.document.contextmenu(EASY.contextMenu.contextMenuRightClick);
        }
        contextMenuObserving = true;
      }
    }
  };

  EASY.contextMenu.toggleIssuesSelection = function (el) {
    var boxes = $(el).parents("form").find("input[type=checkbox]:not(.toggle-selection):visible");
    var all_checked = true;
    boxes.each(function () {
      if (!$(this).prop("checked")) {
        all_checked = false;
      }
    });
    boxes.each(function () {
      var $this = $(this);
      if (all_checked) {
        $this.prop("checked", false);
        $this.parents("tr").removeClass("context-menu-selection");
      } else if (!$(this).prop("checked")) {
        $this.prop("checked", true);
        $this.parents("tr").addClass("context-menu-selection");
      }
    });

    if (el && el.dataset) {
      el.checked = !all_checked;
      var label = el.checked ? el.dataset.uncheckLabel : el.dataset.checkLabel;
      if (label) {
        el.title = label;
        el.setAttribute("aria-label", label);
      }
    }
  };

  EASY.contextMenu.contextMenuRemoveSelection = function (tr, target) {
    tr.removeClass("context-menu-selection");
    contextMenuCheckSelectionBox(tr, false, target);
    contextMenuRegister = $.grep(contextMenuRegister, function (value) {
      return value != tr.attr("id");
    });
  };

  // fallback for redmine plugins
  window.contextMenuInit = EASY.contextMenu.init;
});
